import type { Dayjs } from 'dayjs'

export function withTime(date: Dayjs, time: string): Dayjs | null {
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(time) || !date.isValid()) return null
  const [hour, minute] = time.split(':').map(Number)
  return date.hour(hour).minute(minute).second(0).millisecond(0)
}
